/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiI18nDto } from './kpi-i18n-dto';
import { KpiLastRunSchema } from './kpi-last-run-schema';


export interface KpiSummaryDto { 
    _id: string;
    key: string;
    /**
     * Localized KPI copy keyed by locale.
     */
    i18n: KpiI18nDto;
    programId: string;
    status: KpiSummaryDto.StatusEnum;
    tags: Array<string>;
    latestVersionId?: string | null;
    publishedVersionId?: string | null;
    isLibrary: boolean;
    type?: KpiSummaryDto.TypeEnum;
    configurationStatus?: KpiSummaryDto.ConfigurationStatusEnum;
    /**
     * Latest warehouse run of the published version (else the latest version): duration and slow mark. Null until it has run.
     */
    lastRun?: KpiLastRunSchema | null;
    createdAt?: string;
    updatedAt?: string;
}
export namespace KpiSummaryDto {
    export const StatusEnum = {
        Draft: 'draft',
        Published: 'published',
        Archived: 'archived'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const TypeEnum = {
        Amount: 'amount',
        Count: 'count',
        Chart: 'chart',
        Percentage: 'percentage',
        Trend: 'trend'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const ConfigurationStatusEnum = {
        Ok: 'ok',
        NeedsReconfiguration: 'needs_reconfiguration'
    } as const;
    export type ConfigurationStatusEnum = typeof ConfigurationStatusEnum[keyof typeof ConfigurationStatusEnum];
}


